import React, { useEffect, useCallback, useState} from 'react';
import {truncate} from 'utils/truncate.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {
    setTracksToHide
} from "actions/index.js";

const colors = new Colors();
const NAME_LENGTH = 24;

const HiddenTracks = ({tracksToHide, sequencerEngine, setTracksToHide}) => { 
    let _tracks = tracksToHide.filter(
        x => sequencerEngine.tracks.indexOf(x) > -1);

    _tracks.sort((a, b) => a.trackNumber - b.trackNumber);

    const showTrack = useCallback((track) => {
        let _tracksToHide = [... tracksToHide];
        let i = _tracksToHide.indexOf(track);
        if (i > -1) {
            _tracksToHide.splice(i, 1);
            setTracksToHide(_tracksToHide);
        }
    }, [tracksToHide]);

    return (
        <div className="hidden-tracks">
          {_tracks.map(x => <HiddenTrack onClick={() => showTrack(x)} track={x}/>)}
        </div>
    );
};

const HiddenTrack = ({track, onClick}) => {
    let color = colors.getColorForTrack(track);
    return (
        <div
          onClick={onClick}
          style={{color: color, borderColor: color}} className="hidden-track">
          {track.trackNumber + 1}. {truncate(track.presetName || track.getName(), NAME_LENGTH)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      tracksToHide: state.tracks.tracksToHide,
      currentSubSequence: props.sequencerEngine.currentSubSequence
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setTracksToHide: (tracks) => dispatch(setTracksToHide(tracks)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HiddenTracks);
